export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M15.333 5.333A6.67 6.67 0 0 1 22 12a6.67 6.67 0 0 1-6.667 6.667A6.63 6.63 0 0 1 12 17.771a6.63 6.63 0 0 1-3.333.896A6.67 6.67 0 0 1 2 12a6.67 6.67 0 0 1 6.667-6.667c1.214 0 2.352.327 3.333.895a6.632 6.632 0 0 1 3.333-.895ZM12 6.228a6.665 6.665 0 0 0 0 11.543 6.664 6.664 0 0 0 0-11.543Z"/>
</svg>
`;
